import { render, staticRenderFns } from "./ShippingData.vue?vue&type=template&id=7d50e122&"
import script from "./ShippingData.vue?vue&type=script&lang=js&"
export * from "./ShippingData.vue?vue&type=script&lang=js&"
import style0 from "./ShippingData.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports